import { HttpClient, HttpResponseBase } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LUP_ALINEA_EXTERNAL_URL } from '@loup-transload-ui-app/common-services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PublicProgramService {
  private readonly http = inject(HttpClient);
  private readonly externalUrl = inject(LUP_ALINEA_EXTERNAL_URL);

  /** POST call start */
  searchPublicProgramRequest(requestObj: any) {
    return this.http.post<HttpResponseBase>(
      `${this.externalUrl}transload/find-public-program-locations/1.0`,
      requestObj
    );
  }

  getPublicProgramRate(requestObj: any) {
    return this.http.post<HttpResponseBase>(
      `${this.externalUrl}transload/find-public-program-rates/1.0`,
      requestObj
    );
  }

  getManagerDetails(requestObj: any) {
    return this.http.post<HttpResponseBase>(
      `${this.externalUrl}transload/get-key-values/1.0`,
      requestObj
    );
  }

  getLocationsByGroupName(requestObj: any) {
    return this.http.post<HttpResponseBase>(
      `${this.externalUrl}transload/find-matching-locations/1.0`,
      requestObj
    );
  }

  publishPublicProgram(requestObj: any) {
    return this.http.post<HttpResponseBase>(
      `${this.externalUrl}transload/-`,
      requestObj
    );
  }

  downloadPublicProgramDetailsPdf(id: number): Observable<Blob> {
    const url = `${this.externalUrl}transload/find-public-program-rates/1.0/download`;
    const options = { responseType: 'blob' as const };
    return this.http.post(url, { programId: id }, options);
  }
}
